import { useHandler } from "@chatbotgang/etude/react/useHandler";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";

export const useValidateUrl = () => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  const validateUrl = useHandler((url: string): boolean => {
    if (!url.trim()) {
      return false;
    }

    try {
      const urlObj = new URL(url);
      // Validate that the protocol is http or https
      if (!["http:", "https:"].includes(urlObj.protocol)) {
        enqueueSnackbar(t("productFeed.urlFeed.error.invalidProtocol"), {
          variant: "error",
        });
        return false;
      }
      return true;
    } catch {
      enqueueSnackbar(t("productFeed.urlFeed.error.invalidUrl"), {
        variant: "error",
      });
      return false;
    }
  });

  return validateUrl;
};
